import _implicitStylesheets from "./inputWrapper.css";
import _implicitScopedStylesheets from "./inputWrapper.scoped.css?scoped=true";
import _c360TextArea from "c360/textArea";
import _c360Input from "c360/input";
import _appxMessageBox from "appx/messageBox";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "slds-grid": true,
    "slds-wrap": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "slds-size_1-of-4": true,
    "slds-p-horizontal_medium": true,
    "slds-m-bottom_small": true
  },
  key: 4
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element, h: api_element} = $api;
  return [api_element("div", stc0, [api_element("div", {
    className: api_normalize_class_name($cmp.widthClassCss),
    key: 1
  }, [$cmp.isTextArea ? api_custom_element("c360-text-area", _c360TextArea, {
    props: {
      "overview": $cmp.overview,
      "label": $cmp.label,
      "maxLength": $cmp.maxLength,
      "placeholder": $cmp.placeholder,
      "value": $cmp.value,
      "badge": $cmp.badge,
      "helpInputMessage": $cmp.helpInputMessage,
      "disabled": $cmp.disabled,
      "showRemainingCharacters": $cmp.showRemainingCharacters,
      "alwaysShowRemainingCharacters": $cmp.alwaysShowRemainingCharacters,
      "getCharactersRemainingText": $cmp.getCharactersRemainingText,
      "changeCallback": $cmp.changeCallback,
      "changeFocus": $cmp.onFocus,
      "changeBlur": $cmp.onBlur,
      "required": $cmp.required,
      "requiredText": $cmp.requiredText,
      "forceShowError": $cmp.showInputErrors,
      "labelledBy": $cmp.ariaLabelledBy,
      "rows": $cmp.textAreaRows
    },
    key: 2
  }) : null, $cmp.isTextInput ? api_custom_element("c360-input", _c360Input, {
    props: {
      "label": $cmp.label,
      "overview": $cmp.overview,
      "badge": $cmp.badge,
      "type": $cmp.type,
      "maxLength": $cmp.maxLength,
      "placeholder": $cmp.placeholder,
      "value": $cmp.value,
      "disabled": $cmp.disabled,
      "helpInputMessage": $cmp.helpInputMessage,
      "showRemainingCharacters": $cmp.showRemainingCharacters,
      "getCharactersRemainingText": $cmp.getCharactersRemainingText,
      "changeCallback": $cmp.changeCallback,
      "changeFocus": $cmp.onFocus,
      "changeBlur": $cmp.onBlur,
      "required": $cmp.required,
      "requiredText": $cmp.requiredText,
      "invalidEmailError": $cmp.invalidEmailError,
      "invalidOrgIdError": $cmp.invalidOrgIdError,
      "invalidCampaignIdError": $cmp.invalidCampaignIdError,
      "invalidUrlError": $cmp.invalidUrlError,
      "forceShowError": $cmp.showInputErrors,
      "labelledBy": $cmp.ariaLabelledBy,
      "maxValue": $cmp.maxValue,
      "invalidMaxValueError": $cmp.invalidMaxValueError
    },
    key: 3
  }) : null]), api_element("div", stc1, [$cmp.helpText ? api_element("div", {
    className: api_normalize_class_name($cmp.helpTextCss),
    key: 5
  }, [api_custom_element("appx-message-box", _appxMessageBox, {
    props: {
      "type": "note",
      "message": $cmp.helpText,
      "noteTitle": $cmp._helpTextTitle,
      "linkTarget": $cmp.linkTarget,
      "withoutIcon": $cmp.helpTextWithoutIcon
    },
    key: 6
  })]) : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3evrumtf4o7";
tmpl.legacyStylesheetToken = "appx-inputWrapper_inputWrapper";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
